import React, { useEffect, useRef } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useMount } from 'react-use';

import {
  ADD_FEATURE_TYPE,
  compilePath,
} from '../../../../common/utils/helpers/routes';
import AddPlace from '../add-place/AddPlace';
import {
  activeItemChanged,
  selectActiveItem,
  selectActiveItemIndex,
} from '../../../item-details/store';
import {
  clearFormState,
  clearLastSentEditMetadata,
  clearRoutablePoints,
  setLastSentEditMetadata,
} from '../../../../common/store/item-edit';
import { selectSearchParams } from '../../../../common/store/search';

interface RouteMatch {
  featureType;
}

const AddPlacePage = (props) => {
  const item = useSelector(selectActiveItem);
  const searchSelectedFeatureIndex = useSelector(selectActiveItemIndex);
  const searchParams = useSelector(selectSearchParams);
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    params: { featureType },
  } = useRouteMatch<RouteMatch>();
  const startEditTimestampRef = useRef<number>();

  useMount(() => {
    dispatch(clearLastSentEditMetadata());
    dispatch(activeItemChanged({ item: null }));
  });

  useEffect(() => {
    if (!Object.values(ADD_FEATURE_TYPE).includes(featureType)) {
      dispatch(clearFormState());
      dispatch(clearRoutablePoints());
    }
  }, [dispatch, featureType]);

  useEffect(() => {
    if (Object.values(ADD_FEATURE_TYPE).includes(featureType)) {
      startEditTimestampRef.current = Date.now();
    }
  }, [featureType, dispatch]);

  return (
    <>
      <AddPlace
        item={item}
        searchSelectedFeatureIndex={searchSelectedFeatureIndex}
        searchQuery={searchParams && searchParams.query}
        {...props}
        onSubmit={(editSuggestionSendingResult) => {
          dispatch(
            setLastSentEditMetadata({
              startEditTimestamp: startEditTimestampRef.current!,
              feedbackType: `add ${featureType.replace('-', ' ')}`,
              editSuggestionId: editSuggestionSendingResult.editSuggestionId,
              featureType,
            }),
          );

          history.replace({
            pathname: compilePath('thank-you'),
            search: history.location.search,
          });
        }}
        onCancel={() => history.goBack()}
      />
    </>
  );
};

export default AddPlacePage;
